// Module
var code = "\n<div class=\"{{ form.htmlClass }}\" ng-if=\"form.value\" ng-bind-html=\"form.value\"></div>\n<div class=\"{{form.htmlClass}}\" ng-if=\"!form.value\">\n  <bootstrap-decorator form=\"item\" ng-repeat=\"item in form.items\"></bootstrap-decorator>\n</div>";
// Exports
export default code;